import "../sass/main.scss";
import "./reservation";
import "./salles";
import "./navigation";
import "./home";
